import { createContext } from "react";

export const BrowsingSessionContext = createContext(null);
